import { ELEMENT_GROUPS } from './../utils';

const BottomSheetElementFields = {
  group: ELEMENT_GROUPS.OTHER,
  label: 'Bottom Sheet',
  icon: 'DocumentTextIcon',
  description:
    'Displays a bottom sheet that pops-up from the bottom of the screen',
  properties: ['layout', 'color', 'font', 'alignment', 'margin', 'padding']
};

export default BottomSheetElementFields;
